import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import BaseLineup from 'services/sports/default/base-lineup';
import Const from 'constants';

export default class LineupClassic extends BaseLineup {
    getValidationRules({defaultValue = {}, ...rest}) {
        const {playersLock} = Action.getState();

        return {
            lockedPlayers: playersLock.getMergedLockedPlayerIds(),
        };
    }

    setPlayersByColumns({incomingValues: {team, lineupId}}) {
        const {sportConfig} = Action.getState();

        const params = {
            team,
            sportConfig,
            functions: this.exec(
                'getFunctionsToSetPlayersByColumns',
                {
                    lineupId,
                },
                {},
            ),
        };

        let players = PositionInLineup.set.inDependenceOnDistribution(params);

        if (!sportConfig.isModeLateswap()) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.POSITION_UTIL],
            });

            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.POSITION_UTIL],
                isPlayerSubstitutable: (toPlayer) => toPlayer.positionInLineup === Const.MLB_FD_POSITION_1BC,
                getSubstitutablePositionNames: function (player) {
                    const map = {
                        '1B': ['1B', 'C'],
                        C: ['1B', 'C'],
                    };

                    return map[player.positionName] || [player.positionName];
                },
            });
        }

        return [...players];
    }
}
